import { takeLatest } from 'redux-saga/effects';

import * as handbookActions from '../actions';
import {
    fetchTemplatesSummaryOfChangesSaga,
    acceptTemplatesPolicySummaryOfChangesSaga,
    sendHandbookReminderSaga,
} from './fetch';

/**
 * The root `handbook` saga.
 * We're triggering sagas based their respective events.
 *
 * @method handbooksTemplatesSaga
 * @type   {Generator}
 */
function* handbooksTemplatesSaga() {
    yield takeLatest(
        handbookActions.fetchTemplatesSummaryOfChanges.TRIGGER,
        fetchTemplatesSummaryOfChangesSaga
    );
    yield takeLatest(
        handbookActions.acceptTemplatesPolicySummaryOfChanges.TRIGGER,
        acceptTemplatesPolicySummaryOfChangesSaga
    );
    yield takeLatest(handbookActions.sendHandbookReminder.TRIGGER, sendHandbookReminderSaga);
}

export default handbooksTemplatesSaga;

export {
    fetchTemplatesSummaryOfChangesSaga,
    acceptTemplatesPolicySummaryOfChangesSaga,
    sendHandbookReminderSaga,
};
